import {
  FETCH_NEW_UPDATES_REQUEST,
  FETCH_NEW_UPDATES_SUCCESS,
  FETCH_NEW_UPDATES_FAILURE,
} from "../actions/newUpdatesActions";

const initialState = {
  loading: false,
  data: {},
  error: null,
};

const newUpdatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NEW_UPDATES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_NEW_UPDATES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case FETCH_NEW_UPDATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default newUpdatesReducer;
